import React from 'react'
import './profileInfoChip.css'
import { useHistory } from 'react-router-dom'
import { handleRedirectInternal } from '../../../common/components'

const VARIANTS = {
    small: {
        container: 'd-flex align-items-center justify-content-center profilePicContainer1',
        textTag: 'h6',
        textClass: '',
        imgClass: '',
    },
    large: {
        container: 'productUserInfo',
        textTag: 'span',
        textClass: 'user-name',
        imgClass: 'user-avatar',
    },
}

// eslint-disable-next-line react/prop-types
function ProfileInfoChip({ id, profilePic, name, variant = 'small' }) {
    const currentVariant = VARIANTS[variant] || VARIANTS.large
    const TextTag = currentVariant.textTag
    const history = useHistory()

    const handleClick = (e) => {
        e.stopPropagation()
        if (!id) return
        handleRedirectInternal(history, `myArtists/${id}`)
    }

    return (
        <div
            className={currentVariant.container}
            onClick={handleClick}
            style={{ cursor: 'pointer', zIndex: 999 }}
        >
            <img src={profilePic} alt={name} className={currentVariant.imgClass} />
            <TextTag className={currentVariant.textClass}>{name}</TextTag>
        </div>
    )
}

export default ProfileInfoChip
